module.exports = __webpack_public_path__ + "static/media/YM57_8.4d345378.jpg";